import { Controller } from "@hotwired/stimulus"
import NoteFormController from "./note_form_controller"

// Connects to data-controller="note-stats"
export default class NoteStatsController extends Controller<HTMLElement> {
  static targets = ["words", "chars"]
  static outlets = ["note-form"]

  declare readonly wordsTarget: HTMLElement
  declare readonly charsTarget: HTMLElement
  declare readonly hasNoteFormOutlet: boolean
  declare readonly noteFormOutlet: NoteFormController

  // Lifecycle
  noteFormOutletConnected() {
    this.update()
  }

  // Actions
  update() {
    if (!this.hasNoteFormOutlet) return

    const text = this.noteFormOutlet.editorText.trim()
    const words = text === "" ? 0 : text.split(/\s+/).length

    this.wordsTarget.textContent = String(words)
    this.charsTarget.textContent = String(text.length)
  }
}
